import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import BannerImage from "./banner.svg";
import FlexiImage from "./flexi.svg";
import OpinionHeaderImage from "./opinion-header.svg";
import OpinionImage from "./opinion.svg";
import SectionBlockMobileImage from "./section-block-mobile.svg";
import SectionBlockSmallMobileImage from "./section-block-small-mobile.svg";
import SectionBlockImage from "./section-block.svg";
import TopNewsMobileImage from "./top-news-mobile.svg";
import TopNewsImage from "./top-news.svg";
import TopSmallNewsImage from "./top-small-news.svg";

export const StyledBannerImage = styled(BannerImage)`
  ${theme.breakpoints.only("tablet")} {
    display: none;
  }

  ${theme.breakpoints.only("mobile")} {
    margin-block-start: 24px;
    padding-block-start: 24px;
    border-block-start: 1px solid #dfdfdf;
  }
`;

export const StyledFlexiImage = styled(FlexiImage)`
  ${theme.breakpoints.down("desktop")} {
    display: none;
  }
`;

export const StyledOpinionHeaderImage = styled(OpinionHeaderImage)`
  ${theme.breakpoints.down("desktop")} {
    display: none;
  }
`;

export const StyledOpinionImage = styled(OpinionImage)`
  ${theme.breakpoints.down("desktop")} {
    display: none;
  }
`;

export const StyledTopNewsImage = styled(TopNewsImage)`
  ${theme.breakpoints.down("tablet")} {
    display: none;
  }
`;

export const StyledTopSmallNewsImage = styled(TopSmallNewsImage)`
  margin-block: 24px;
  padding-block: 24px;
  border-block: 1px solid #dfdfdf;

  ${theme.breakpoints.down("tablet")} {
    display: none;
  }
`;

export const StyledSectionBlockImage = styled(SectionBlockImage)`
  :not(:first-of-type) {
    margin-block-start: 24px;
    padding-block-start: 24px;
    border-block-start: 1px solid #dfdfdf;
  }

  ${theme.breakpoints.down("tablet")} {
    display: none;
  }
`;

export const StyledSectionBlockMobileImage = styled(SectionBlockMobileImage)`
  display: block;

  margin-block-start: 24px;
  padding-block-start: 24px;
  border-block-start: 1px solid #dfdfdf;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const StyledSectionBlockSmallMobileImage = styled(SectionBlockSmallMobileImage)`
  display: block;

  :not(:first-of-type) {
    margin-block-start: 24px;
    padding-block-start: 24px;
    border-block-start: 1px solid #dfdfdf;
  }

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const StyledTopNewsMobileImage = styled(TopNewsMobileImage)`
  display: block;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const Container = styled.div`
  inline-size: 100%;
  ${setFullViewportWidthStyles}
`;

export const ContentContainer = styled.div`
  display: grid;
  grid:
    "top-news" max-content
    "banner" max-content
    "section-block" max-content
    / 100%;

  max-inline-size: 1024px;
  margin-block: 20px;
  margin-inline: auto;
  padding-inline: 20px;

  animation-name: placeholderAnimate;
  animation-duration: 1.7s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;

  @keyframes placeholderAnimate {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  ${theme.breakpoints.up("tablet")} {
    grid:
      "top-news" max-content
      "top-small-news" max-content
      "section-block" max-content
      / 100%;

    margin-block: 32px;
    padding-inline: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    grid:
      "top-news . vertical-line . banner" max-content
      "top-small-news . vertical-line . flexi" max-content
      "section-block . vertical-line . flexi" max-content
      "section-block . vertical-line . opinion" max-content
      / minmax(0, 1fr) 24px 1px 24px 300px;

    max-inline-size: 1272px;
  }

  svg {
    inline-size: 100%;
    box-sizing: content-box;
  }
`;

export const VerticalLine = styled.div`
  grid-area: vertical-line;
  border-inline-start: 1px solid #dfdfdf;

  block-size: 100%;
`;

export const Banner = styled.div`
  grid-area: banner;

  inline-size: 100%;
`;

export const Flexi = styled.div`
  grid-area: flexi;

  inline-size: 100%;
  padding-block-start: 24px;
`;

export const Opinion = styled.div`
  grid-area: opinion;

  inline-size: 100%;
  padding-block-start: 24px;
`;

export const TopNews = styled.div`
  grid-area: top-news;

  inline-size: 100%;
`;

export const TopSmallNews = styled.div`
  grid-area: top-small-news;

  inline-size: 100%;
`;

export const SectionBlock = styled.div`
  grid-area: section-block;

  inline-size: 100%;
`;
